<template>
<div class="col-lg-7 m-3">
<div class="input-group ">
    <input type="search" class="form-control" placeholder="Cerca" aria-label="Cerca" v-model="parola" @input="cerca()">
    <!-- <div class="input-group-append">
   <button class="btn btn-outline-secondary" type="button" @click="cerca()">Cerca</button>
  </div> -->
</div>
</div>
</template>

<script>
import SegnalazioniDataService from '@/service/SegnalazioniDataService.js'

export default {
  name: 'cerca',
  data () {
    return {
      codiceComune: this.$store.getters.getComune.codiceCatasto,
      parola: null
    }
  },
  methods: {
    cercaSegnalazioni (idc, string) {
      return SegnalazioniDataService
        .cerca(idc, string)
        .then(response => {
          console.log(response.data)
          return response.data
        })
        .catch(e => {
          console.log(e)
          return []
        })
    },

    cerca () {
      clearTimeout(this.debounce)
      console.log(this.$store.getters.getComune.codiceCatasto)
      this.debounce = setTimeout(() => {
        this.cercaSegnalazioni(this.$store.getters.getComune.codiceCatasto, this.parola.toLowerCase()).then(risultato => {
          console.log('hai cercato', this.parola)
          this.$emit('cerca', risultato)
        })
      }, 300)
    }
  }
}
</script>
